/**
 * @author      luis.orihuela@agileengine.com (Luis Orihuela)
 * @copyright   Copyright (c) 2022, Zumper
 * @description amenity filter constants for STR
 */
import { BuildingAmenity, ListingAmenity } from '@zcode/enums'

// TODO: replace with enum
export const STR_HOT_TUB_KEY = `l-${ListingAmenity.HOT_TUB}`
export const STR_PRIVATE_POOL_KEY = `l-${ListingAmenity.PRIVATE_POOL}`
export const STR_HEATED_POOL_OR_INDOOR_POOL_KEY = `l-${ListingAmenity.HEATED_INDOOR_POOL}`

// Location keys
export const BEACH_KEY = `l-${ListingAmenity.BEACH}`
export const LAKE_KEY = `l-${ListingAmenity.LAKE}`
export const WATERFRONT_KEY = `l-${ListingAmenity.WATERFRONT}`
export const MOUNTAINS_KEY = `l-${ListingAmenity.MOUNTAINS}`
export const OCEAN_KEY = `l-${ListingAmenity.OCEAN}`
export const SKI_IN_SKI_OUT_KEY = `l-${ListingAmenity.SKI_IN_SKI_OUT}`

export const AIR_CONDITION_KEY = `l-${ListingAmenity.AIR_CONDITIONING}`
export const ASSIGNED_PARKING_KEY = `l-${ListingAmenity.ASSIGNED_PARKING}`
export const BALCONY_KEY = `l-${ListingAmenity.BALCONY}`
export const BREAKFAST_INCLUDED_KEY = `l-${ListingAmenity.BREAKFAST_INCLUDED}`
export const CABLE_KEY = `l-${ListingAmenity.CABLE}`
export const CENTRAL_HEAT_KEY = `l-${ListingAmenity.CENTRAL_HEAT}`
export const COFFEE_TEA_MAKER_KEY = `l-${ListingAmenity.COFFEE_TEA_MAKER}`
export const DISHWASHER_KEY = `l-${ListingAmenity.DISHWASHER}`
export const DOOR_PERSON_KEY = `b-${BuildingAmenity.DOOR_PERSON}`
export const ELEVATOR_KEY = `b-${BuildingAmenity.ELEVATOR}'`
export const EV_CHARGING_KEY = `l-${ListingAmenity.EV_CHARGING}`
export const FIREPLACE_KEY = `l-${ListingAmenity.FIREPLACE}`
export const FREE_PARKING_KEY = `l-${ListingAmenity.FREE_PARKING}`
export const FURNISHED_KEY = 'l-13'
export const GARAGE_PARKING_KEY = `b-${BuildingAmenity.GARAGE_PARKING}`
export const GYM_KEY = `b-${BuildingAmenity.FITNESS_CENTER}`
export const HARDWOOD_FLOOR_KEY = 'l-11'
export const HIGH_CEILINGS_KEY = `l-${ListingAmenity.HIGH_CEILINGS}`
export const HOUSEKEEPING_KEY = `l-${ListingAmenity.HOUSEKEEPING}`
export const KITCHEN_KEY = `l-${ListingAmenity.KITCHEN}`
export const LAUNDRY_BUILDING_KEY = `b-${BuildingAmenity.ON_SITE_LAUNDRY}`
export const LAUNDRY_IN_UNIT_KEY = `l-${ListingAmenity.IN_UNIT_LAUNDRY}`
export const LAUNDRY_KEY = `l-${ListingAmenity.ON_SITE_LAUNDRY}`
export const MICROWAVE_KEY = `l-${ListingAmenity.MICROWAVE}`
export const OUTDOOR_SPACE_KEY = `b-${BuildingAmenity.OUTDOOR_SPACE}`
export const OVEN_KEY = `l-${ListingAmenity.OVEN}`
export const POOL_KEY = `b-${BuildingAmenity.SWIMMING_POOL}`
export const POOL_LISTING_KEY = `l-${ListingAmenity.POOL}`
export const TOILETRIES_KEY = `l-${ListingAmenity.TOILETRIES}`
export const TV_KEY = `l-${ListingAmenity.TV}`
export const WHEELCHAIR_KEY = `b-${BuildingAmenity.WHEELCHAIR_ACCESSIBLE}`
export const WIFI_KEY = `l-${ListingAmenity.WIFI}`
export const WORKSPACE_KEY = `l-${ListingAmenity.WORKSPACE}`

export const LAUNDRY_OR_KEY = 'OR-100'
export const PARKING_OR_KEY = 'OR-101'
export const POOL_OR_KEY = 'OR-102'
export const OUTDOOR_SPACE_OR_KEY = 'OR-103'
export const BUILDING_LAUNDRY_OR_KEY = 'OR-104'

// Or amenities keys
export const OR_LAUNDRY_BUILDING_KEY = `b${BuildingAmenity.ON_SITE_LAUNDRY}`
export const OR_LAUNDRY_IN_UNIT_KEY = `l${ListingAmenity.IN_UNIT_LAUNDRY}`
export const OR_LAUNDRY_KEY = `l${ListingAmenity.ON_SITE_LAUNDRY}`

export const OR_ASSIGNED_PARKING_KEY = `l${ListingAmenity.ASSIGNED_PARKING}`
export const OR_FREE_PARKING_KEY = `l${ListingAmenity.FREE_PARKING}`
export const OR_GARAGE_PARKING_KEY = `b${BuildingAmenity.GARAGE_PARKING}`

export const OR_POOL_KEY = `b${BuildingAmenity.SWIMMING_POOL}`
export const OR_POOL_LISTING_KEY = `l${ListingAmenity.POOL}`

export const OR_BALCONY_KEY = `l${ListingAmenity.BALCONY}`
export const OR_GARDEN_KEY = `l${ListingAmenity.GARDEN}`
export const OR_DECK_KEY = `l${ListingAmenity.DECK}`
export const OR_ROOF_DECK_KEY = `b${BuildingAmenity.ROOF_DECK}`
export const OR_OUTDOOR_SPACE_KEY = `b${BuildingAmenity.OUTDOOR_SPACE}`

export const orAmenitiesLaundry = [OR_LAUNDRY_KEY, OR_LAUNDRY_IN_UNIT_KEY, OR_LAUNDRY_BUILDING_KEY]

export const orAmenitiesBuildingLaundry = [OR_LAUNDRY_KEY, OR_LAUNDRY_BUILDING_KEY]

export const orAmenitiesParking = [
  OR_ASSIGNED_PARKING_KEY,
  OR_FREE_PARKING_KEY,
  OR_GARAGE_PARKING_KEY,
]

export const orAmenitiesPool = [OR_POOL_KEY, OR_POOL_LISTING_KEY]

export const orAmenitiesOutdoorSpaces = [
  OR_BALCONY_KEY,
  OR_GARDEN_KEY,
  OR_DECK_KEY,
  OR_ROOF_DECK_KEY,
  OR_OUTDOOR_SPACE_KEY,
]

export const OR_AMENITIES: { [key: string]: string[] } = {
  [PARKING_OR_KEY]: orAmenitiesParking,
  [LAUNDRY_OR_KEY]: orAmenitiesLaundry,
  [POOL_OR_KEY]: orAmenitiesPool,
  [OUTDOOR_SPACE_OR_KEY]: orAmenitiesOutdoorSpaces,
  [BUILDING_LAUNDRY_OR_KEY]: orAmenitiesBuildingLaundry,
}

export const basicAmenities = {
  [AIR_CONDITION_KEY]: 'Air conditioning',
  [LAUNDRY_OR_KEY]: 'Laundry',
  [CENTRAL_HEAT_KEY]: 'Central heating',
  [PARKING_OR_KEY]: 'Parking',
  [TV_KEY]: 'TV',
  [WIFI_KEY]: 'Wifi',
}

export const moreAmenities = {
  [STR_HOT_TUB_KEY]: 'Hot tub',
  [POOL_OR_KEY]: 'Pool',
  [STR_PRIVATE_POOL_KEY]: 'Private pool',
  [STR_HEATED_POOL_OR_INDOOR_POOL_KEY]: 'Heated pool or indoor pool',
  [DISHWASHER_KEY]: 'Dishwasher',
  [EV_CHARGING_KEY]: 'EV charging',
  [BREAKFAST_INCLUDED_KEY]: 'Breakfast/Meals',
  [TOILETRIES_KEY]: 'Bathroom amenities',
  [MICROWAVE_KEY]: 'Microwave',
  [ELEVATOR_KEY]: 'Elevator',
  [GYM_KEY]: 'Gym',
  [FIREPLACE_KEY]: 'Fireplace',
  [HOUSEKEEPING_KEY]: 'Housekeeping',
  [COFFEE_TEA_MAKER_KEY]: 'Tea/coffee maker',
  [OVEN_KEY]: 'Oven',
  [DOOR_PERSON_KEY]: 'Door person',
  // [CABLE_KEY]: 'Cable',
}

export const locationAmenities = {
  [LAKE_KEY]: 'Lake',
  [WATERFRONT_KEY]: 'Waterfront',
  [BEACH_KEY]: 'Beach',
  [OCEAN_KEY]: 'Oceanfront',
  [SKI_IN_SKI_OUT_KEY]: 'Ski in/Ski out',
  [MOUNTAINS_KEY]: 'Mountains',
}

export const basicAmenitiesKeys = [
  AIR_CONDITION_KEY,
  LAUNDRY_KEY,
  CENTRAL_HEAT_KEY,
  LAUNDRY_BUILDING_KEY,
  TV_KEY,
  LAUNDRY_IN_UNIT_KEY,
  ASSIGNED_PARKING_KEY,
  GARAGE_PARKING_KEY,
  WIFI_KEY,
]

export const accessibilityAmenityKeys = [DOOR_PERSON_KEY, ELEVATOR_KEY, WHEELCHAIR_KEY]

export const otherSpacesAmenities = {
  [KITCHEN_KEY]: 'Kitchen',
  [OUTDOOR_SPACE_OR_KEY]: 'Outdoor space',
  [WORKSPACE_KEY]: 'Workspace',
}

export const popularAmenities = {
  [LAUNDRY_IN_UNIT_KEY]: 'In unit laundry',
  [DISHWASHER_KEY]: 'Dishwasher',
  [AIR_CONDITION_KEY]: 'A/C',
  [GARAGE_PARKING_KEY]: 'Garage parking',
}
